import React from 'react';
import Typography from '@mui/material/Typography';

interface ListTitleProps {
  title: string;
}

function ListTitle({ title }: ListTitleProps) {
  return (
    <Typography
      component="h1"
      className="tracking-widest text-2xl max-md:text-xl font-bold leading-[30px]  mb-6 max-sm:w-full max-sm:mb-5"
    >
      {title}
    </Typography>
  );
}

export default ListTitle;
